import { LocationInfo, LocationSource } from './Location';
import { Observable, Subject } from 'rxjs';
import { MyNavigator } from 'typings/globals/cordova';

declare const navigator: MyNavigator;

export class IpGeolocationPlugin implements LocationSource {
  private source$Subject: Subject<LocationInfo>;
  source$: Observable<LocationInfo>;

  constructor() {
    this.source$Subject = new Subject<LocationInfo>();
    this.source$ = this.source$Subject.shareReplay(1);
  }

  private networkAccuracy() {
    if (navigator.connection && (navigator.connection.type === 'wifi' || navigator.connection.type === 'ethernet')) {
      return 'CITY';
    }
    return 'COUNTRY';
  }

  getLocation(): Promise<LocationInfo> {
    return fetch(`${URL_API_HOST}/api/v2/location-by-ip`)
      .then(r => {
        if (r.status === 200) {
          return r.json();
        }
        return Promise.reject('unable to resolve location by ip');
      })
      .then(({ lat, lon }) => ({ latitude: lat, longitude: lon }))
      /* eslint no-restricted-globals: "off" */
      .then(location => ({ location, source: 'IP', quality: this.networkAccuracy() }))
      .then((l: LocationInfo) => {
        console.debug('ipLocationGet', location);
        this.source$Subject.next(l);
        return l;
      })
      .catch(e => {
        console.error(e);
        return null;
      });
  }
}
